import React,{ useEffect,useState } from "react";
import { Redirect, Switch, Route ,useParams } from "react-router-dom";
import { shallowEqual, useSelector , useDispatch } from "react-redux";
import queryString from "query-string";
import BasePage from "./BasePage";
import EsyncPage from "./EsyncPage";
import { AuthPage } from "./modules/Auth";
import logout from "./modules/Auth/pages/Logout";
import { useIdleTimer } from 'react-idle-timer';
import { actions } from 'app/modules/Auth/_redux/authRedux';
import OTP from 'app/modules/Auth/pages/OTP';

export function Routes() {

  const encounterID = window.location.href.split('/provider-note/')[1] || window.location.search.split('&id=')[1];
  
  const dispatch = useDispatch();

  const { id } = useParams();

  const [isIdle, setIsIdle] = useState(false);

  const [noteId,setNoteId] = useState((pre)=>{
    if(!pre) {
      const { id: noteId } = queryString.parse(location.search);
      return noteId;
    }
  });

  const [ApptID, setApptID] = useState((pre)=>{
    if(!pre) {
      const esyncApptCheck1 = window.location.href.split('&esync_appt=');
      const esyncApptCheck2 = window.location.href.split("/esync_apt/");
      const esyncApptCheck2_1 = (esyncApptCheck2?.length && esyncApptCheck2?.length > 1) ? esyncApptCheck2[1]?.split('-') : [];
      const eSyncApptID =  (esyncApptCheck1?.length && esyncApptCheck1?.length > 1) ? esyncApptCheck1[1] : (esyncApptCheck2_1?.length && esyncApptCheck2_1?.length > 1) ? (esyncApptCheck2_1[0]) : null;
      const ApptID = eSyncApptID;
      return ApptID;
    }
  });

  const [create10xEncounter, setCreate10xEncounter] = useState((pre)=>{
    if(!pre) {
      const { e10x_note_practice: create10xEncounter } = queryString.parse(location.search);
      return create10xEncounter;
    }
  });

  const { isAuthorized,idleEncounters } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth && auth.practice_id && auth.user != null,
      idleEncounters: auth && auth.idleEncounters,
    }),
    shallowEqual
  );

  const handleOnIdle = () => {
    let noteeID = noteId ? noteId :  encounterID;
    if(noteeID && !ApptID) {
      const data = [...idleEncounters];
      data.push(noteeID);
      dispatch(actions.setIdleEncounter(data));
    }
  };

  const {
    reset
  } = useIdleTimer({
    timeout: (1000 * 60 * 60),
    onIdle: handleOnIdle
  })

  const handleReset = () => {
    reset(); 
    let noteeID = noteId ? noteId :  encounterID;
    let data = [...idleEncounters];
    dispatch(actions.setIdleEncounter(data.filter((encounter)=> (encounter != noteeID))));
  };

  useEffect(()=>{
    if(!ApptID && idleEncounters && (noteId ||  encounterID)){
      let noteeID = noteId ? noteId :  encounterID;
      let idle = idleEncounters?.find((encounter)=>( encounter === noteeID));
      if(idle) {
        setIsIdle(true);
        return;
      } else {
        setIsIdle(false);
        return;
      }
    }
  },[idleEncounters, noteId, encounterID, ApptID]);

  return (
    <Switch>
      {!isAuthorized ? (
        <Route>
          <AuthPage />
        </Route>
      ) : (
        <Redirect from="/auth" to="/" />
      )}
      <Route path="/logout" component={logout} />
      {!isAuthorized ? <Redirect to="/auth/login" /> : <>
        <div style={{'display': isIdle ? 'block': 'none'}}>
          <OTP handleReset={handleReset} isIdle={isIdle} />
        </div>
        <div style={{'display': !isIdle ? 'block': 'none'}}>
          {(ApptID) ? <EsyncPage apptID={ApptID} e10xEncounter={create10xEncounter} /> : <BasePage noteId={noteId} />}
        </div>
      </>}
    </Switch>
  );
}
